import { render } from "./DurationSelector.vue?vue&type=template&id=477672c2"
import script from "./DurationSelector.vue?vue&type=script&lang=js"
export * from "./DurationSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__